<template>
  <div class="distributor-search">
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="mb-3">
            <label for="servicetype" class="form-label">Type of Business</label>
            <select v-model="servicetypeFilter" id="servicetype" class="form-select">
                <option value="">Select One</option>
                <option v-for="(serviceType, index) in servicetypeOptions" :key="index" :value="serviceType">{{ serviceType }}</option>
            </select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div v-if="servicetypeFilter != ''" class="mb-3">
            <label for="state" class="form-label">State</label>
            <select v-model="stateFilter" id="state" class="form-select">
                <option value="">Select One</option>
                <option v-for="(state, index) in stateOptions" :key="index" :value="index">{{ state }}</option>
            </select>
        </div>
      </div>
    </div>
    <div v-if="searchComplete">
      <div v-if="distributors.length" class="distributor-list-wrapper">
        <DistributorCard
            v-for="(distributor) in distributors"
            :key="distributor.id"
            :distributor="distributor"
        />
      </div>
      <div v-else class="no-models">No Distributors Found</div>
    </div>
  </div>
</template>

<script>
/* global distributors, stateOptions, servicetypeOptions */

import DistributorCard from './components/DistributorCard.vue'

export default {
  name: 'DistributorSearch',
  components: {
    DistributorCard
  },
  data () {
    return {
      allDistributors: distributors,
      distributors: [],
      stateOptions: stateOptions,
      servicetypeOptions: servicetypeOptions,
      servicetypeFilter: '',
      stateFilter: '',
      searchComplete: false
    }
  },
  watch: {
    servicetypeFilter: function () {
      this.filterDistributors()
    },
    stateFilter: function () {
      this.filterDistributors()
    }
  },
  methods: {
    filterDistributors: function () {
      this.distributors = []
      this.searchComplete = false
      if (this.servicetypeFilter.length > 0 && this.stateFilter.length > 0) {
        for (var i = 0; i < this.allDistributors.length; i++) {
          var hide = false
          var checkDistributor = this.allDistributors[i]

          if (checkDistributor.service_types.indexOf(this.servicetypeFilter) < 0) {
            hide = true
          }

          if (!hide) {
            if (checkDistributor.states.indexOf(this.stateFilter) < 0) {
              hide = true
            }
          }

          if (!hide) {
            this.distributors.push(checkDistributor)
          }
        }

        this.searchComplete = true
      }
    }
  }
}
</script>
